import get from 'lodash.get';

import type { WizardOpenConfig } from '../ltl.types';

type LtlCoreState = {
  isWizardOpen: boolean;
  wizardOpenConfig: WizardOpenConfig | null;
  isCancellingShipment: boolean;
  isDownloadingDocument: boolean;
};

export const selectIsWizardOpen = (state: LtlCoreState): boolean => get(state, 'isWizardOpen', false);
export const selectWizardOpenConfig = (state: LtlCoreState): WizardOpenConfig | null => get(state, 'wizardOpenConfig', null);
export const selectIsCancellingShipment = (state: LtlCoreState): boolean => get(state, 'isCancellingShipment', false);
export const selectIsDownloadingDocument = (state: LtlCoreState): boolean => get(state, 'isDownloadingDocument', false);
